import { Shark, Utils } from "shark-mvc";
// import $ from "jquery";
import moment from "moment";

import ViewBase from "../ViewBase";

import templateContent from "./construction-site-list.html";

import { activityReportComponent } from "../../_shark_jaws/components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import applicatorTeamManager from "../../_shark_jaws/managers/applicatorTeamManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { constructionSiteActionsComponent } from "../../components/constructionSiteActions/constructionSiteActionsComponent";
import { constructionSiteManager } from "../../_shark_jaws/managers/constructionSiteManager";
import { constructionSiteMultiDateComponent } from "../../components/constructionSiteMultiDate/constructionSiteMultiDateComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import { documentListView } from "../../views/documents/documentListView";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { notComplianceReportListView } from "../../views/constructionSite/notComplianceReportListView";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import showAllContactsButtonComponent from "../../components/showAllContactsButton/showAllContactsButtonComponent";
import teamUpManager from "../../_shark_jaws/managers/teamUpManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class ConstructionSiteListView extends ViewBase {
	constructor () {
		super("constructionSiteListView");

		this.setTemplate(templateContent);
	}

	// Dave: unificare
	addTeamCloseDocumentBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);
	
		if (currConstructionSite) {
			Shark.set({currConstructionSite});
			followUpComponent.set("targetItem", currConstructionSite);
			constructionSiteActionsComponent.show("sendTeamCloseDocument");
		}
	}

	replaceTeamCloseDocumentBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);
	
		if (currConstructionSite) {
			Shark.set({currConstructionSite});
			followUpComponent.set("targetItem", currConstructionSite);
			constructionSiteActionsComponent.show("replaceTeamCloseDocument");
		}
	}


	afterComponentsPreRender () {
		//Dave: Questo giro andrebbe modificato per usare constructionSiteGroupList
		let constructionSiteList = Shark.get("constructionSiteList");
		let __presumedAmountTotal = 0;

		if (constructionSiteList) {
			const { constructionSiteActiveFilters, dateRangeFilter } = Shark.get();

			constructionSiteList.forEach((item) => {
				if (!dateRangeFilter.ignoreDateRange && (item.__startDate < dateRangeFilter.__from || item.__startDate > dateRangeFilter.__to) &&
					(
						(item.__endDate === "" && (item.__expectedEndDate < dateRangeFilter.__from || item.__expectedEndDate > dateRangeFilter.__to))
						||
						(item.__endDate !== "" && (item.__endDate < dateRangeFilter.__from || item.__endDate > dateRangeFilter.__to))
					)
					&& (item.__updatedAt < dateRangeFilter.__from || item.__updatedAt > dateRangeFilter.__to)
				) {
					item.__render = false;
				}
				else {
					item.__render = [1, 6].indexOf(item.status) > -1  && constructionSiteActiveFilters.showCSStarted ||
					// item.status === 2 && constructionSiteActiveFilters.showCSEnded && constructionSiteActiveFilters.showCompliant ||
					[2, 7].indexOf(item.status) > -1 && constructionSiteActiveFilters.showCSEnded && constructionSiteActiveFilters.showCompliant ||
					item.status === 5 && constructionSiteActiveFilters.showCSEnded && constructionSiteActiveFilters.showNotCompliant ||
					// item.status === 3 && constructionSiteActiveFilters.showCSClosed && constructionSiteActiveFilters.showCompliant ||
					[3, 8].indexOf(item.status) > -1 && constructionSiteActiveFilters.showCSClosed && constructionSiteActiveFilters.showCompliant ||
					item.status === 4 && constructionSiteActiveFilters.showCSClosed && constructionSiteActiveFilters.showNotCompliant
					;
				}

				//Dave: Ecco, questo è il caso perfetto in cui il ModelRenderer dovrebbe fare il suo lavoro...
				//Dave.ToDo: Questo avrebbe senso che venisse sostituito col metodo di validazione del dateRangeFilter
				if ((item.__startDate < dateRangeFilter.__from || item.__startDate > dateRangeFilter.__to) && (item.__updatedAt >= dateRangeFilter.__from && item.__updatedAt <= dateRangeFilter.__to)) {
					item.__updatedAtDateLabel = "<span class=\"filter-matched-field-display\">" + item.__updatedAtLabel + "</span>";
				}
				else {
					item.__updatedAtDateLabel = item.__updatedAtLabel;
				}

				if (item.__render) {
					__presumedAmountTotal += item.__presumedAmount ? item.__presumedAmount : 0;
				}
			});
		}

		const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
		const __presumedAmountTotalLabel = formatterCurrency.format(__presumedAmountTotal);

		this.set({
			__presumedAmountTotalLabel,
		});

		exportCSVComponent.set({
			listToExport: Shark.get("constructionSiteList").filter(item => item.__render),
		});

		Shark.set({
			activityReport: activityReportComponent.extractReport(constructionSiteList),
		});
	}

	async beforeLoad () {
		window.scrollTo(0, 0);

		const constructionSiteList = Shark.get("constructionSiteList");

		activityReportComponent.set("__reportType", "Cantieri");
		liveSearchComponent.behavior = "database";
		liveSearchComponent.set({searchHint: "Il testo inserito verrà cercato nel nome del contatto, nel luogo di intervento, nella CCA."});
		followUpComponent.set("targetItem", null);
		constructionSiteMultiDateComponent.set("referenceListName", "constructionSiteList");
	
		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			await applicatorTeamManager.getList();
		}

		if (Shark.get("clientList").length === 0) {
			clientManager.getList();
		}
	
		if (constructionSiteList.length === 0) {
			this.refreshList(null, true);
		}
		else {
			// Dave.Info: Se ho già una lista faccio un refresh "default" > carica solo se ci sono filtri diversi (es la provincia.)
			this.refreshList();
		}

		userManager.getRequireAttentionCounts();//Dave: Avremo le notifiche per aggiornare questi numeri

		this.set({
			__htmlTitle: "Cantieri | IPM HUB",
		});
	
		exportCSVComponent.set({
			savedFileBaseName: "Lista Cantieri",
			exportMap: {
				name: "Cantieri",
				id: "constructionSiteFieldMap",
				fields: {
					["registry.clientName"]: "Cliente",
					["registry.clientEMail"]: "Contatto eMail",
					__siteLocationLabel: "Cantiere",
					__clientContactSourceLabel: "Origine",
					__agentName: "Agente",
					__presumedAmount: "Importo presunto",
					["__reportData.area"]: "mq",
					// ----: "Linee prodotti", //Dave.ToDo: bisogna recuperare i dati dalla CSC.
				},
			},
		});
	}
	
	beforeRender () {
		const constructionSiteList = Shark.get("constructionSiteList");
		const hiliteConstructionSite = Shark.get("hiliteConstructionSite");
	
		if (hiliteConstructionSite) {
			constructionSiteList.forEach(item => item.__hilited = item.guid === hiliteConstructionSite.guid);
		}
	
		followUpComponent.set({
			sourceList: constructionSiteList
		});
	}

	beforeUnload () {		
		Shark.set({
			hiliteConstructionSite: null
		});
	}
			
	closeConstructionSiteBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);
	
		if (currConstructionSite) {
			currConstructionSite.set("__endDate", moment().format(Shark.get("dtIsoDate")));
			Shark.set({currConstructionSite});
			followUpComponent.set("targetItem", currConstructionSite);
			constructionSiteActionsComponent.show();
		}
	}
	
	init () {
		this.addComponents([activityReportComponent, agentFilterComponent, constructionSiteActionsComponent, constructionSiteMultiDateComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, provinceFilterComponent, refreshListButtonComponent, showAllContactsButtonComponent, waitBoxComponent]);
		
		const currUser = Shark.get("currUser");
		const filtersStatus = this.getFiltersStatus();

		const constructionSiteActiveFilters = Shark.getInstance("__smart__", {
			closedCount: 0,
			compliantCount: 0,
			endedCount: 0,
			startedCount: 0,
			notCompliantCount: 0,
			showCompliant: filtersStatus ? filtersStatus.showCompliant : !currUser.hasPermission("editNotComplianceReportForIPM"),
			showCSClosed: filtersStatus ? filtersStatus.showCSClosed : currUser.hasPermission("editNotComplianceReportForIPM"),
			showCSEnded: filtersStatus ? filtersStatus.showCSEnded : !currUser.hasPermission("editNotComplianceReportForIPM"),
			showCSStarted: filtersStatus ? filtersStatus.showCSStarted : !currUser.hasPermission("editNotComplianceReportForIPM"),
			showNotCompliant: filtersStatus ? filtersStatus.showNotCompliant : true,
			__showCSClosedSubFilters: filtersStatus ? (filtersStatus.showCSClosed || filtersStatus.showCSEnded) : currUser.hasPermission("editNotComplianceReportForIPM"),
		});

		constructionSiteActiveFilters.on("dataChanged", function () {
			constructionSiteListView.saveFiltersStatus(this);
			this.__showCSClosedSubFilters = this.showCSClosed || this.showCSEnded;

			if (this.showCSStarted || (this.showCSEnded && (this.showCompliant || this.showNotCompliant)) || (this.showCSClosed && (this.showCompliant || this.showNotCompliant))) {
				constructionSiteListView.refreshList();
			}
			else {
				Shark.render();
			}
		});

		Shark.set({
			clientList: Shark.get("clientList") || [],
			constructionSiteActiveFilters,
			constructionSiteList: Shark.get("constructionSiteList") || [],
		});
	}

	readFullCloseNotesBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite) {
			informationModalComponent.show({body: currConstructionSite.extraData.closeNotes, title: "Note di chiusura"});
		}
	}

	refreshList (range = null, force = false) {
		waitBoxComponent.show();

		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const { agentFilter, dateRangeFilter, constructionSiteActiveFilters, provinceFilter } = Shark.get();
		const filters = constructionSiteActiveFilters.export();

		delete filters.closedCount;
		delete filters.compliantCount;
		delete filters.endedCount;
		delete filters.startedCount;
		delete filters.notCompliantCount;
		delete filters.__showCSClosedSubFilters;

		if (provinceFilter.province !== "all") {
			filters.province = provinceFilter.province;
		}

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}

		// Dave.ToDo: Portare tutto in una funzione, lo faccio ovunque!
		if (!force) {
			if (localStorage.constructionSiteListViewLastFilters) {
				if (localStorage.constructionSiteListViewLastFilters === JSON.stringify({filters, range})) {
					refreshListButtonComponent.resetStatus();
					waitBoxComponent.hide();
					return;
				}
			}
		}

		return constructionSiteManager.getFilteredList({filters, range, incrementalRequest})
		.then(response => {
			localStorage.constructionSiteListViewLastFilters = JSON.stringify({filters, range});

			const provinceForFilterComponentSet = new Set();
			response.data.forEach(item => provinceForFilterComponentSet.add(item.registry.clientProvince));
	
			//Dave: Spostalo nel componente
			let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
			provinceForFilterComponent.sort();
			provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});
	
			waitBoxComponent.hide();
			Shark.set({provinceForFilterComponent});
			Shark.render();
			return true;
		});
	}

	updateDateBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite) {
			const quotationCCA = currConstructionSite.extraData.quotationCCA.trim();

			if (quotationCCA !== "") {
				event.target.classList.add("loading");

				teamUpManager.updateDataByCCA(quotationCCA)
				.then(response => {
					console.log({response});
					event.target.classList.remove("loading");

					if (!response.constructionSiteCard) {
						informationModalComponent.show({body: "Attenzione, la CCA inserita non corrisponde a nessun evento sul calendario TeamUp", title: "Informazione"});
					}
					else {
						this.refreshList();
					}
				});
			}
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				clientName: searchKey,
				quotationCCA: searchKey,
				siteLocation: searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}

	updateTotals () {
		let constructionSiteList = Shark.get("constructionSiteList");
		let presumedAmountTotal = 0;

		constructionSiteList.forEach(item => {
			const node = document.querySelector(`.singleItemBox[data-guid="${item.guid}"]`);

			if (node && !node.classList.contains("d-none") && node.style.display !== "none") {
				presumedAmountTotal += item.__presumedAmount ? parseFloat(item.__presumedAmount) : 0;
			}
		});

		const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
		const __presumedAmountTotalLabel = formatterCurrency.format(presumedAmountTotal);
	
		this.set({
			__presumedAmountTotalLabel,
		});

		const node = document.querySelector(`[data-ref="presumedAmountTotal"]`);
		if (node) {
			node.innerHTML = __presumedAmountTotalLabel;
		}
	}






	
	showConstructionSiteFolderBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite && currConstructionSite.constructionSiteCardGuid !== "") {
			folderManager.getPathByReferenceGuid(currConstructionSite.constructionSiteCardGuid)
			.then(folderResponse => {
				console.log({folderResponse});
				
				if (folderResponse.data.length > 0) {
					Shark.set({
						requestedFolderBreadCrumb: folderResponse.data
					});
					Shark.openPage(documentListView);
				}
			});
		}
		else if (currConstructionSite && currConstructionSite.constructionSiteFolderGuid !== "") {
			folderManager.getPathByGuid(currConstructionSite.constructionSiteFolderGuid)
			.then(folderResponse => {
				console.log({folderResponse});
				
				if (folderResponse.data.length > 0) {
					Shark.set({
						requestedFolderBreadCrumb: folderResponse.data
					});
					Shark.openPage(documentListView);
				}
			});
		}
	}

	showNotComplianceReportList_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite) {
			Shark.set({currConstructionSite});
			followUpComponent.set("targetItem", currConstructionSite);
			Shark.openPage(notComplianceReportListView);
		}
	}

	showSiteInfoSheetFolderBtn_clickHandler (event, data) {
		const currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite) {
			folderManager.getPathByReferenceGuid(currConstructionSite.extraData.relatedGuids.siteInfoSheetGuid)
			.then(folderResponse => {
				console.log({folderResponse});
				
				if (folderResponse.data.length > 0) {
					Shark.set({
						requestedFolderBreadCrumb: folderResponse.data
					});
					Shark.openPage(documentListView);
				}
			});
		}
	}
}

const constructionSiteListView = new ConstructionSiteListView();

Shark.registerView(constructionSiteListView);

export default constructionSiteListView;
